export default class BookingEngine {
	/**
	 * Constructor
	 *
	 * @param {Object} config Configuration options
	 */
	constructor ({ hotelID }) {
		this.baseUrl = 'https://reservations.cubilis.eu/be/';
		this.language = 'en';
		this.advance = "";
		this.config = {
			hotelID
		};
	}

	/**
	 * Convert a string representation of a date to a date object
	 *
	 * @param {*} date Date as an object or string
	 * @returns {String} Date as a string
	 */
	dateToString (date) {
		if (typeof date === 'string') {
			return date;
		}

		return date.getFullYear()
			+ '-'
			+ ('0' + (date.getMonth() + 1)).slice(-2)
			+ '-'
			+ ('0' + date.getDate()).slice(-2);
	}

	/**
	 * Open the booking engine
	 *
	 * @param {object} options  Options object
	 *
	 * @return {void}
	 */
	getUrl (options) {
		if (!options.language) {
			options.language = this.language;
		}

		if (options.hotelid) {
			this.config.hotelID = options.hotelid;
		}
		
		if (options.arrival && options.departure) {
			this.advance = "/Rooms/Select";
		}

		const url = new URL(this.baseUrl + this.config.hotelID  + this.advance);
		url.search = (new URL(document.location)).searchParams;

		url.searchParams.append('Language', options.language);

		if (options.arrival) {
			url.searchParams.append('Arrival', this.dateToString(options.arrival));
		}

		if (options.departure) {
			url.searchParams.append('Departure', this.dateToString(options.departure));
		}

		if (options.promotioncode) {
			url.searchParams.append('DiscountCode', options.promotioncode);
		}

		if (options.roomid) {
			url.searchParams.append('Room', options.roomid);
		}

		if (options.packageid) {
			url.searchParams.append('Package', options.packageid);
		}

		return url.href;
	}
}
